import { useMutation, useQueryClient } from "@tanstack/react-query"
import * as authApi from "@/api/endpoints/auth"
import { userKeys } from "./user"

export const useLoginMutation = () =>
  useMutation({
    mutationFn: authApi.login,
  })

export const useRegisterMutation = () =>
  useMutation({
    mutationFn: authApi.register,
  })

export const useLinkBusinessOwnerAccountMutation = () =>
  useMutation({
    mutationFn: authApi.linkBusinessOwnerAccount,
  })

export const useForgotPasswordMutation = () =>
  useMutation({
    mutationFn: authApi.forgotPassword,
  })

export const useChangePasswordMutation = () =>
  useMutation({
    mutationFn: authApi.changePassword,
  })

export const useVerifyOtpMutation = () =>
  useMutation({
    mutationFn: authApi.verifyOtp,
  })

export const useUpdateUserMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: authApi.updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.profile() })
    },
  })
}

export const useVerifyEmailMutation = () =>
  useMutation({
    mutationFn: authApi.verifyEmail,
  })

export const useGoogleAuthenticationMutation = () =>
  useMutation({
    mutationFn: authApi.googleAuthentication,
  })

export const useAppleAuthenticationMutation = () =>
  useMutation({
    mutationFn: authApi.appleAuthentication,
  })
